module.exports = __webpack_public_path__ + "static/media/Maps-Early-Filter-Concept.5537e8a4.mp4";